import React, { Fragment, useState } from 'react'
import Header from '../../components/header/Header'
// import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer'
import { Link } from 'react-router-dom'

const Register = props => {
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev)
  }

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(prev => !prev)
  }

  return (
    <Fragment>
      <Header />
      <main className='page_content about-page'>
        {/* <PageTitle pageTitle={'Register'} pagesub={'In 😍'} pageTop={'Log'} /> */}

        <section className='portfolio_details_section section_space bg-light'>
          <div className='container'>
            <form className='login'>
              <h1 className='text-center'>Register</h1>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='form-group'>
                    <label className='input_title' htmlFor='input_name'>
                      Full Name
                    </label>
                    <input type='text' name='fullName' className='form-control' />
                  </div>
                </div>

                <div className='col-md-12'>
                  <div className='form-group'>
                    <label className='input_title' htmlFor='input_email'>
                      Email
                    </label>
                    <input type='email' name='email' className='form-control' />
                  </div>
                </div>

                <div className='col-md-12'>
                  <div className='form-group'>
                    <label className='input_title' htmlFor='input_phone'>
                      Phone
                    </label>
                    <input type='tel' name='phone' className='form-control' />
                  </div>
                </div>

                <div className='col-md-12'>
                  <div className='form-group'>
                    <label className='input_title' htmlFor='input_password'>
                      Password
                    </label>
                    <div className='position-relative'>
                      <input
                        type={showPassword ? 'text' : 'password'}
                        name='password'
                        className='form-control'
                      />
                      <button
                        type='button'
                        onClick={togglePasswordVisibility}
                        className='password-show'
                      >
                        <i
                          className={
                            showPassword
                              ? 'fa-regular fa-eye-slash'
                              : 'fa-regular fa-eye'
                          }
                        ></i>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Confirm Password */}
                <div className='col-md-12'>
                  <div className='form-group'>
                    <label className='input_title' htmlFor='confirm_password'>
                      Confirm Password
                    </label>
                    <div className='position-relative'>
                      <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        name='confirmPassword'
                        className='form-control'
                      />
                      <button
                        type='button'
                        onClick={toggleConfirmPasswordVisibility}
                        className='password-show'
                      >
                        <i
                          className={
                            showConfirmPassword
                              ? 'fa-regular fa-eye-slash'
                              : 'fa-regular fa-eye'
                          }
                        ></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div className='col-md-12 text-center'>
                  <button type='submit' className='btn btn-primary'>
                    <span className='btn_label' data-text='Register'>
                      Register
                    </span>
                    <span className='btn_icon'>
                      <i className='fa-solid fa-arrow-up-right'></i>
                    </span>
                  </button>

                  <p className='text-center mt-3 mb-0 text-white contentP'>
                    Already have an account?
                    <Link className='underline' to='/login'>
                      Login
                    </Link>
                  </p>
                </div>
              </div>
            </form>
          </div>
        </section>  
      </main>

      <Footer />
      <Scrollbar />
    </Fragment>
  )
}

export default Register
